import React from "react";
import { useTranslation } from "react-i18next";

import type { TProfTreeListItem } from "@app/types";
export const ProfileListIco = ({ e }: { e: any }) => {
  const { data }: { data: TProfTreeListItem } = e;
  switch (true) {
    case data.ptlCfgPage === "whoami":
      return <i className={`dx-icon dx-icon-user`} />;
    case data.ptlCfgPage === "distribution":
      return <i className={`dx-icon dx-icon-home`} />;
    case data.ptlCfgPage === "distro/users":
      return <i className={`dx-icon dx-icon-group`} />;
    case data.ptlCfgPage === "distro/files":
      return <i className={`dx-icon dx-icon-file`} />;
    case data.ptlCfgPage === "distro/license":
      return <i className={`dx-icon dx-icon-bookmark`} />;
    default:
      return <i className={`dx-icon dx-icon-home`} />;
  }
};

export const ProfileListTitle = ({ e }: { e: any }) => {
  const { t } = useTranslation();
  return <span>{t(e.data?.ptlTitle || "<title>")}</span>;
};
